/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cover_Letter_PlaceholderInputs */

const en_cover_letter_placeholder = /** @type {(inputs: Cover_Letter_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Write your cover letter here...`)
};

const de_cover_letter_placeholder = /** @type {(inputs: Cover_Letter_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Schreiben Sie hier Ihr Anschreiben...`)
};

/**
* | output |
* | --- |
* | "Write your cover letter here..." |
*
* @param {Cover_Letter_PlaceholderInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const cover_letter_placeholder = /** @type {((inputs?: Cover_Letter_PlaceholderInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cover_Letter_PlaceholderInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_cover_letter_placeholder(inputs)
	return en_cover_letter_placeholder(inputs)
});